// If you want to show a nux when a new user visits, just add it to the return value for this component
export function AllNuxes() {
  return <></>;
}
